import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@statsbomb/kitbag-components';
import { LoaderWrapper, LoaderLabel } from './LoaderLabelled.styles';

const LoaderLabelled = ({ text = '', fadeIn, height = 'inherit' }) => (
  <LoaderWrapper fadeIn={fadeIn} $height={height}>
    <Loader />
    {text && <LoaderLabel>{text}</LoaderLabel>}
  </LoaderWrapper>
);

LoaderLabelled.propTypes = {
  text: PropTypes.string,
  fadeIn: PropTypes.bool,
  height: PropTypes.string,
};

export default LoaderLabelled;
